export const STATUS_IDLE = 'idle';
export const STATUS_PENDING = 'pending';
export const STATUS_SUCCESS = 'success';
export const STATUS_FAILED = 'failed';